module.exports = __webpack_public_path__ + "img/dep-just-sky-s.91e61d78.jpg";